import React from 'react';
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import * as BsIcons from "react-icons/bs";

export const SidebarData = [
    {
        title: 'Inicio',
        label: 'inicio',
        path: '/gestion_proyecto',
        icon: <BsIcons.BsGrid1X2Fill />,
    },
    {
            title: 'Parámetros',
            label: 'parametros',
            path: '#',
            icon: <FaIcons.FaTasks />,
            iconClosed: <RiIcons.RiArrowDownSFill />,
            iconOpened: <RiIcons.RiArrowUpSFill />,
            subNav: [
                {
                    title: 'Periodos',
                    path: '/gestion_proyecto',
                    path_s: 'periodos',
                    icon: <BsIcons.BsFillCalendarDateFill />,
                },
                {
                    title: 'Tipo de Cambio',
                    path: '/gestion_proyecto',
                    path_s: 'tipo_cambio',
                    icon: <BsIcons.BsCoin />,
                },
            ]
    },
    {
        title: 'Presupuesto',
        label: 'presupuesto',
        path: '#',
        icon: <FaIcons.FaListUl />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: 'Linea presupuestaria',
                path: '/gestion_proyecto',
                path_s: 'linea_presupuestaria',
                icon: <FaIcons.FaListUl />,
            },
            {
                title: 'Presupuesto',
                path: '/gestion_proyecto',
                path_s: 'presupuesto',
                icon: <BsIcons.BsFillGrid3X2GapFill />,
            },
        ]
    },
    {
        title: 'Mano de obra',
        label: 'mano_bora',
        path: '#',
        icon: <FaIcons.FaListUl />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: 'Tipo MDO',
                path: '/gestion_proyecto',
                path_s: 'tipo_mano_obra',
                icon: <FaIcons.FaListUl />,
            },
            {
                title: 'Colaboradores',
                path: '/gestion_proyecto',
                path_s: 'colaboradores',
                icon: <FaIcons.FaListUl />,
            },
            {
                title: 'Actividad',
                path: '/gestion_proyecto',
                path_s: 'actividad_mano_obra',
                icon: <FaIcons.FaListUl />,
            },
            {
                title: 'Mano de obra',
                path: '/gestion_proyecto',
                path_s: 'mano_obra',
                icon: <BsIcons.BsBricks />,
            },
        ]
    },
    {
        title: 'Proyecto',
        label: 'proyecto',
        path: '#',
        icon: <FaIcons.FaListUl />,
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,
        subNav: [
            {
                title: 'Proyecto',
                path: '/gestion_proyecto',
                path_s: 'seleccionar_proyecto',
                icon: <FaIcons.FaListUl />,
            },
            {
                title: 'Tipo de gasto',
                path: '/gestion_proyecto',
                path_s: 'tipo_gasto',
                icon: <BsIcons.BsFillGrid3X2GapFill />,
            },
            {
                title: 'Gastos de proyecto',
                path: '/gestion_proyecto',
                path_s: 'seleccionar_gastos_proyecto',
                icon: <BsIcons.BsFillFolderFill />,
            },
            {
                title: 'Cierre de proyecto',
                path: '/gestion_proyecto',
                path_s: 'cierre_proyecto',
                icon: <FaIcons.FaClipboardCheck />,
            },
        ]
    },
    {
        title: 'Informes',
        label: 'informes',
        path: '/gestion_proyecto/informes',
        icon: <FaIcons.FaClipboard />,
    }
]

